function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M424.53,752.64l-25.65-101.1h13.8l12,51.15c3,12.6,5.7,25.2,7.5,34.95h.3c1.65-10,4.8-22,8.25-35.1l13.5-51h13.65l12.29,51.3c2.85,12,5.55,24,7.05,34.65h.3c2.1-11.1,5-22.35,8.1-35l13.35-51h13.35l-28.65,101.1H480L467.27,700a306.6,306.6,0,0,1-6.59-33h-.3a315.85,315.85,0,0,1-7.8,33l-14.4,52.65Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M536.88,718.74c.3,17.85,11.7,25.2,24.9,25.2,9.45,0,15.15-1.65,20.1-3.75l2.25,9.45c-4.65,2.1-12.6,4.5-24.15,4.5-22.35,0-35.7-14.7-35.7-36.6s12.9-39.15,34.05-39.15c23.7,0,30,20.85,30,34.2a49.79,49.79,0,0,1-.45,6.15Zm38.7-9.45c.15-8.4-3.45-21.45-18.3-21.45-13.35,0-19.2,12.3-20.25,21.45Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M619.38,659.64c.15,4.5-3.15,8.1-8.4,8.1a7.85,7.85,0,0,1-8-8.1,8,8,0,0,1,8.25-8.25C616.23,651.39,619.38,655,619.38,659.64Zm-14.7,93V680h13.2v72.6Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M702.32,680c-.3,5.25-.6,11.1-.6,20v42.15c0,16.65-3.3,26.85-10.35,33.15-7,6.6-17.24,8.7-26.39,8.7-8.7,0-18.3-2.1-24.15-6l3.3-10a40.94,40.94,0,0,0,21.3,5.7c13.49,0,23.39-7,23.39-25.35v-8.1h-.3c-4,6.75-11.85,12.15-23.09,12.15-18,0-30.9-15.3-30.9-35.4,0-24.6,16.05-38.55,32.7-38.55,12.59,0,19.49,6.6,22.64,12.6h.3l.6-11Zm-13.65,28.65a18.8,18.8,0,0,0-.75-6c-2.4-7.65-8.85-14-18.44-14-12.6,0-21.6,10.65-21.6,27.45,0,14.25,7.2,26.1,21.45,26.1a19.29,19.29,0,0,0,18.29-13.5,23,23,0,0,0,1-7Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M723.63,646.14h13.19v45.3h.3a24.49,24.49,0,0,1,9.45-9.3,27.17,27.17,0,0,1,13.5-3.75c9.75,0,25.35,6,25.35,31.05v43.2h-13.2v-41.7c0-11.7-4.35-21.6-16.8-21.6-8.55,0-15.3,6-17.7,13.2a16,16,0,0,0-.9,6.3v43.8H723.63Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M822.17,659.19V680h18.9v10.05h-18.9v39.15c0,9,2.55,14.1,9.9,14.1a29.36,29.36,0,0,0,7.65-.9l.6,9.9a32.31,32.31,0,0,1-11.7,1.8c-6.15,0-11.1-1.95-14.25-5.55-3.75-3.9-5.1-10.35-5.1-18.9v-39.6H798V680h11.25v-17.4Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M888.17,652.89a126.45,126.45,0,0,1,23.85-2.1c13.05,0,21.45,2.25,27.75,7.35,5.25,3.9,8.4,9.9,8.4,17.85,0,9.75-6.45,18.3-17.1,22.2v.3c9.6,2.4,20.85,10.35,20.85,25.35a27.25,27.25,0,0,1-8.55,20.25c-7,6.45-18.45,9.45-35,9.45a152.56,152.56,0,0,1-20.25-1.2Zm13.05,41.4h11.85c13.8,0,21.9-7.2,21.9-16.95,0-11.85-9-16.5-22.2-16.5a56,56,0,0,0-11.55.9Zm0,48.45a69.73,69.73,0,0,0,10.95.6c13.5,0,26-5,26-19.65,0-13.8-11.85-19.5-26.1-19.5h-10.8Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1035.32,715.74c0,26.85-18.6,38.55-36.15,38.55-19.65,0-34.8-14.4-34.8-37.35,0-24.3,15.9-38.55,36-38.55C1021.22,678.39,1035.32,693.54,1035.32,715.74Zm-57.6.75c0,15.9,9.15,27.9,22,27.9,12.6,0,22.05-11.85,22.05-28.2,0-12.3-6.15-27.9-21.75-27.9S977.72,702.69,977.72,716.49Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1050.17,739.14a34.59,34.59,0,0,0,17.4,5.25c9.6,0,14.1-4.8,14.1-10.8,0-6.3-3.75-9.75-13.5-13.35-13.05-4.65-19.2-11.85-19.2-20.55,0-11.7,9.45-21.3,25-21.3a36.24,36.24,0,0,1,17.85,4.5l-3.3,9.6a28.25,28.25,0,0,0-14.85-4.2c-7.8,0-12.15,4.5-12.15,9.9,0,6,4.35,8.7,13.8,12.3,12.6,4.8,19.05,11.1,19.05,21.9,0,12.75-9.9,21.75-27.15,21.75-8,0-15.3-1.95-20.4-4.95Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1109.57,739.14a34.59,34.59,0,0,0,17.4,5.25c9.6,0,14.1-4.8,14.1-10.8,0-6.3-3.75-9.75-13.5-13.35-13-4.65-19.2-11.85-19.2-20.55,0-11.7,9.45-21.3,25.05-21.3a36.24,36.24,0,0,1,17.85,4.5l-3.3,9.6a28.25,28.25,0,0,0-14.85-4.2c-7.8,0-12.15,4.5-12.15,9.9,0,6,4.35,8.7,13.8,12.3,12.6,4.8,19,11.1,19,21.9,0,12.75-9.9,21.75-27.15,21.75-8,0-15.3-1.95-20.4-4.95Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#786c64"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M429.73,748.13,404.08,647h13.8l12,51.14c3,12.6,5.7,25.2,7.5,35h.3c1.65-10,4.8-22,8.25-35.1l13.5-51h13.65l12.3,51.29c2.85,12,5.55,24,7.05,34.65h.3c2.1-11.1,4.95-22.35,8.1-35l13.34-51h13.35L498.88,748.13H485.23l-12.75-52.65a304.28,304.28,0,0,1-6.6-33h-.3a316.32,316.32,0,0,1-7.8,33l-14.4,52.65Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M542.08,714.23c.3,17.85,11.7,25.2,24.9,25.2,9.45,0,15.15-1.65,20.1-3.75l2.25,9.45c-4.65,2.1-12.6,4.5-24.15,4.5-22.35,0-35.7-14.7-35.7-36.6s12.9-39.15,34-39.15c23.7,0,30,20.85,30,34.2a49.79,49.79,0,0,1-.45,6.15Zm38.7-9.45c.15-8.4-3.45-21.45-18.3-21.45-13.35,0-19.2,12.3-20.25,21.45Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M624.58,655.14c.15,4.5-3.15,8.1-8.4,8.1a7.85,7.85,0,0,1-7.95-8.1,8,8,0,0,1,8.25-8.25C621.43,646.89,624.58,650.49,624.58,655.14Zm-14.7,93v-72.6h13.2v72.6Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M707.53,675.53c-.3,5.25-.6,11.1-.6,20v42.15c0,16.65-3.3,26.85-10.35,33.15-7.05,6.6-17.25,8.7-26.4,8.7-8.7,0-18.3-2.1-24.15-6l3.3-10.05a40.94,40.94,0,0,0,21.3,5.7c13.5,0,23.4-7,23.4-25.35v-8.1h-.3c-4.05,6.75-11.85,12.15-23.1,12.15-18,0-30.9-15.3-30.9-35.4,0-24.6,16-38.55,32.7-38.55,12.6,0,19.5,6.6,22.65,12.6h.3l.6-11Zm-13.65,28.65a18.8,18.8,0,0,0-.75-6c-2.4-7.65-8.85-13.95-18.45-13.95-12.6,0-21.6,10.65-21.6,27.45,0,14.25,7.2,26.1,21.45,26.1a19.3,19.3,0,0,0,18.3-13.5,23,23,0,0,0,1-7Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M728.83,641.64H742v45.29h.3a24.49,24.49,0,0,1,9.45-9.3,27.17,27.17,0,0,1,13.5-3.75c9.74,0,25.34,6,25.34,31v43.2h-13.2v-41.7c0-11.7-4.34-21.6-16.79-21.6-8.55,0-15.3,6-17.7,13.2a16,16,0,0,0-.9,6.3v43.8h-13.2Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M827.38,654.69v20.84h18.89v10.05H827.38v39.15c0,9,2.54,14.1,9.89,14.1a29.36,29.36,0,0,0,7.65-.9l.6,9.9a32.29,32.29,0,0,1-11.69,1.8c-6.16,0-11.1-2-14.25-5.55-3.75-3.9-5.1-10.35-5.1-18.9v-39.6H803.23V675.53h11.25V658.14Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M893.37,648.39a126.45,126.45,0,0,1,23.85-2.1c13,0,21.45,2.25,27.75,7.35,5.25,3.9,8.4,9.9,8.4,17.84,0,9.75-6.45,18.3-17.1,22.2v.3c9.6,2.4,20.85,10.35,20.85,25.35a27.25,27.25,0,0,1-8.55,20.25c-7.05,6.45-18.45,9.45-35,9.45a152.56,152.56,0,0,1-20.25-1.2Zm13,41.39h11.85c13.8,0,21.9-7.2,21.9-16.95,0-11.84-9-16.49-22.2-16.49a56,56,0,0,0-11.55.9Zm0,48.45a69.73,69.73,0,0,0,11,.6c13.5,0,26-5,26-19.65,0-13.8-11.85-19.5-26.1-19.5h-10.8Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1040.52,711.23c0,26.85-18.6,38.55-36.15,38.55-19.65,0-34.8-14.4-34.8-37.35,0-24.3,15.9-38.55,36-38.55C1026.42,673.88,1040.52,689,1040.52,711.23Zm-57.6.75c0,15.9,9.15,27.9,22.05,27.9,12.6,0,22-11.85,22-28.2,0-12.3-6.15-27.9-21.75-27.9S982.92,698.18,982.92,712Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M1055.37,734.63a34.59,34.59,0,0,0,17.4,5.25c9.6,0,14.1-4.8,14.1-10.8,0-6.3-3.75-9.75-13.5-13.35-13-4.65-19.2-11.85-19.2-20.55,0-11.7,9.45-21.3,25-21.3a36.24,36.24,0,0,1,17.85,4.5l-3.3,9.6a28.25,28.25,0,0,0-14.85-4.2c-7.8,0-12.15,4.5-12.15,9.9,0,6,4.35,8.7,13.8,12.3,12.6,4.8,19,11.1,19,21.9,0,12.75-9.9,21.75-27.15,21.75-8,0-15.3-2-20.4-5Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M1114.77,734.63a34.59,34.59,0,0,0,17.4,5.25c9.6,0,14.1-4.8,14.1-10.8,0-6.3-3.75-9.75-13.5-13.35-13-4.65-19.2-11.85-19.2-20.55,0-11.7,9.45-21.3,25-21.3a36.24,36.24,0,0,1,17.85,4.5l-3.3,9.6a28.25,28.25,0,0,0-14.85-4.2c-7.8,0-12.15,4.5-12.15,9.9,0,6,4.35,8.7,13.8,12.3,12.6,4.8,19,11.1,19,21.9,0,12.75-9.9,21.75-27.15,21.75-7.95,0-15.3-2-20.4-5Z",
  transform: "translate(-398.88 -641.64)",
  fill: "#efe8e1"
});

var SvgLogotextWeightboss = function SvgLogotextWeightboss(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 760.14 142.35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogotextWeightboss, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logotext_weightboss.9c4efa22.svg";
export { ForwardRef as ReactComponent };